import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=7df57952&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=7df57952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df57952",
  null
  
)

export default component.exports